<template>
  <div class="basic-info-wrapper">
    <div class="profile-image-wrapper">
      <img class="profile-pic" :src="profilePictureURL" alt="user" />
    </div>
    <div class="basic-info">
      <div class="top-row">
        <h5>
          <span v-if="isChat" class="dot"></span>
          {{ name }}
          <span v-if="votingPoints"
            >(broj glasova: &nbsp;{{ votingPoints }})</span
          >
        </h5>
        <p class="date">{{ getChatDate }}</p>
      </div>
      <h6>{{ description | formatDivDescription }}</h6>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { formatDivDescriptionMixin } from '@/mixins/mixins.js';
export default {
  props: {
    profilePictureURL: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true,
      default: ''
    },
    description: {
      type: String,
      required: false
    },
    date: {
      type: String,
      required: false
    },
    votingPoints: {
      type: String,
      required: false
    },
    isChat: {
      type: Boolean,
      required: false
    }
  },
  mixins: [formatDivDescriptionMixin],
  computed: {
    getChatDate() {
      if (this.date) {
        let timeElapsed = new Date() - new Date(this.date);

        let seconds = Math.floor(timeElapsed / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        // let days = Math.floor(hours / 24);
        // let months = Math.floor(days/30);

        if (seconds < 60) {
          if (seconds < 0) {
            return '0s';
          }
          return seconds + 's';
        } else if (minutes < 60) {
          return minutes + 'm';
        } else if (hours < 24) {
          return hours + 'h';
        } else {
          let serbianDate = this.date.split(' ')[0].split('-');
          return serbianDate[2] + '/' + serbianDate[1] + '/' + serbianDate[0];
        }
      }
      return '';
    }
  }
};
</script>

<style scoped lang="scss">
.profile-image-wrapper {
  width: 50px;
  height: 50px;
}
.dot {
  height: 10px;
  width: 10px;
  background-color: var(--primary-color);
  border-radius: 50%;
  display: inline-block;
}
.basic-info-wrapper {
  display: flex;
  position: relative;
  flex: 2;
  h6 {
    width: 100%;
    margin-bottom: 0;
    margin-right: 10px;
  }
}

.profile-pic {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 50%;
  /*overflow: hidden;*/
}

.basic-info {
  padding-left: 10px;
  text-align: start;
  width: 100%;
  .top-row {
    display: flex;
    h5 {
      color: var(--primary-color);
      font-weight: bold;
      flex: 1;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 0px; // ellipsis works only if width is set
    }
    .date {
      color: dimgrey;
      margin: auto 0 0 auto;
      font-size: 12px;
      margin-top: -2px !important;
      // position: absolute;
      // right: 10px;
      // top: 10px;
    }
  }
}
</style>
